import { render, staticRenderFns } from "./folders-filters.vue?vue&type=template&id=3a90192b"
import script from "./folders-filters.vue?vue&type=script&lang=js"
export * from "./folders-filters.vue?vue&type=script&lang=js"
import style0 from "./folders-filters.vue?vue&type=style&index=0&id=3a90192b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports